import styled from 'styled-components';

export const ContainerCR = styled.div`
  text-align: center;
  padding: 20px;
  img {
    width: 200px;
  }
`;
